(function () {
  function activateReveals(root) {
    var reveals = root.querySelectorAll('.wm-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('wm-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        el.classList.add('wm-visible');
      } else {
        io.observe(el);
      }
    });
  }

  function initFaqAccordion(root) {
    root.querySelectorAll('.wm-faq-item').forEach(function (item) {
      var question = item.querySelector('.wm-faq-q');
      if (!question) return;
      question.addEventListener('click', function () {
        item.classList.toggle('wm-open');
      });
    });
  }

  function initPriceOptions(root) {
    // Purchase options are quantities of a single variant (not separate
    // variants), so a click updates the hidden quantity input rather than
    // the variant id — the price shown per option is already
    // unit-price × that option's quantity, computed server-side.
    var options = root.querySelectorAll('.wm-price-option');
    var checkoutButtons = root.querySelectorAll('.wm-btn-checkout');
    var quantityInputs = root.querySelectorAll('.wm-quantity-input');

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('wm-selected'); });
        opt.classList.add('wm-selected');

        var quantity = opt.getAttribute('data-quantity') || '1';
        var priceLabel = opt.getAttribute('data-price-label') || '';

        quantityInputs.forEach(function (input) { input.value = quantity; });
        checkoutButtons.forEach(function (btn) {
          btn.textContent = (btn.getAttribute('data-cta-prefix') || 'Pre-order from') + ' ' + priceLabel;
        });
      });
    });
  }

  function initVslPlayers(root) {
    root.querySelectorAll('.wm-vsl-block.wm-has-video').forEach(function (block) {
      var media = block.querySelector('.wm-vsl-media');
      var poster = block.querySelector('.wm-vsl-poster');
      if (!media || !poster) return;

      function wireVideo(video) {
        video.addEventListener('pause', function () { block.classList.remove('wm-playing'); });
        video.addEventListener('ended', function () { block.classList.remove('wm-playing'); });
      }

      // Dawn's <deferred-media> only inserts the real <video> the first
      // time the poster is clicked. Watch for that insertion so we can:
      // hide the poster immediately (it's about to autoplay), and wire up
      // pause/ended so the poster reappears once playback stops.
      var observer = new MutationObserver(function () {
        var video = media.querySelector('video');
        if (video && !video.dataset.wmWired) {
          video.dataset.wmWired = 'true';
          block.classList.add('wm-playing');
          wireVideo(video);
        }
      });
      observer.observe(media, { childList: true });

      // After the first click, Dawn's own handler becomes a no-op (it only
      // creates the <video> once) — once a video exists, let the poster act
      // as a "resume playback" button so clicking it again after a pause
      // starts the video again instead of doing nothing.
      poster.addEventListener('click', function () {
        var video = media.querySelector('video');
        var deferred = media.closest('deferred-media');
        if (video && deferred && deferred.hasAttribute('loaded')) {
          block.classList.add('wm-playing');
          video.play();
        }
      });
    });
  }

  function init() {
    // Runs against the whole document rather than per .wm-page instance:
    // the journal product page splits its content across several
    // independent sections, but price options / buy buttons / variant
    // input all need to stay in sync across those section boundaries.
    activateReveals(document);
    initFaqAccordion(document);
    initPriceOptions(document);
    initVslPlayers(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
